/*--------------------------------------
CART CLEAN -> CASE EXTRA CHARGES –>
 --------------------------------------*/
 CartClean = {
    searcharray: [],
    init: function () {
        /* 
        Search uniques + extra
        always need a pair
        always have a same quantity
        */
        
        //get cart :)
        $.ajax({
            type: 'GET',
            url: '/cart.js',
            cache: false,
            dataType: 'json',
            success: function(cart) {
                CartClean.search(cart);              
            }
        });
 
        
    },
    search: function (cart){
        console.log (cart['item_count']);
        if (cart['item_count']>0){
            cart['items'].forEach(function(val, index, array){
                //console.log("En el índice " + index + " hay este valor: " + val);
                
                if (val['properties']['regalo'] != undefined){
                    
                    data = {
                        regalo: val['properties']['regalo'],
                        id: val['id'],
                        qty: val['quantity'],
                        line: index,
                    };
                    CartClean.searcharray.push(data);
                }
            });
            CartClean.action(cart);
        }
    },
    action: function(cart){
        // compare items 
        console.table (CartClean.searcharray);
        console.table (cart['items']);

        var found =false;
        CartClean.searcharray.forEach(function (v,i,a){

            cart['items'].forEach(function(val, index, array){
                //console.log (a[i]['regalo'] + ' - '+ array[index]['handle']);
                //console.log ( array[index]['handle'] );
                //console.log ( a[i]['regalo']);

                    if ( a[i]['regalo']== array[index]['handle']){

                           found=true;
                           // get qty and compare –> 
                           if (a[i]['qty']== array[index]['quantity']) {
                                console.log ('Not Update: The quantity of searcharray['+index+'] is same cart['+i+']');  // DIFERENCE QTY
                           }else {
                                console.log ('Update: The quantity of searcharray['+index+'] is different cart['+i+']'); // NOT EXIST
                                console.log ('then put the same quantity –>');
                                url = "/cart/change?line="+(a[i]['line']+1)+"&quantity="+val['quantity'];
                                console.log ('output >'+url);
                                window.location.href = url;return;
                                
                           }
                    }
                
                
                // if not exist dins product –> delete extra –> 
            }); 

            if (found==false){
                // go to delete it –> 
       
                var line =a[i]['line']+1;
                url = "/cart/change?line="+line+"&quantity=0"
                console.log ('Delete: Product id '+i+ ' dont exist deleting line '+line); // NOT EXIST
                console.log (url);
                window.location.href = url;return;
                
            } 
            found =false;   
        });    
    },
    change: function(id,quantity){
        $.ajax({
            type: 'POST', 
            url: '/cart/change.js',
            dataType: 'json', 
            data:  { id:id, quantity:quantity },
            success: CartClean.addToCartOk,
            error: CartClean.addToCartFail
        });
    },
    addToCartOk:function(){
        //location.reload();
    }
    ,
    addToCartFail:function(){
        //error with update
    }

};

$( document ).ready(function() {
    CartClean.init()
});